import type { ResourceExtension as ResourceExtensionModel } from '@/adapters/catalogv1.g';

export function extractResourceExtension(model: ResourceExtensionModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    resourceRef: model.resource_ref ?? '',
    permissionCount: model.permissions?.length ?? 0,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogResourceExtension = ReturnType<
  typeof extractResourceExtension
>;
